import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "t2-main" }
const _hoisted_2 = { class: "t2-content" }
const _hoisted_3 = { class: "container mar_b" }
const _hoisted_4 = { class: "userContainer" }
const _hoisted_5 = { class: "t6_title" }
const _hoisted_6 = {
  cellpadding: "0",
  cellspacing: "0",
  border: "0",
  class: "table_fix table_style"
}
const _hoisted_7 = {
  colspan: "6",
  style: {"height":"360px","overflow":"hidden","width":"1800px"}
}
const _hoisted_8 = { class: "bxsliderNew width100" }
const _hoisted_9 = { style: {"width":"280px","text-align":"center"} }
const _hoisted_10 = { style: {"width":"200px","text-align":"center"} }
const _hoisted_11 = { style: {"width":"270px","text-align":"center"} }
const _hoisted_12 = { style: {"width":"180px","text-align":"center"} }
const _hoisted_13 = { style: {"width":"150px","text-align":"center"} }
const _hoisted_14 = { style: {"width":"100px","text-align":"center"} }

import {onBeforeMount, onMounted, ref} from 'vue'
import {useRoute, useRouter} from 'vue-router'
import {Vue3SeamlessScroll} from 'vue3-seamless-scroll';
import {getUrl, queryPreServiceCountData, queryBusinessCountData, queryComplainCountData} from "@/config/request";
import dayjs from "dayjs";
import {create} from "axios";


export default /*@__PURE__*/_defineComponent({
  __name: 'Publicity',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const itemList = ref([]);
const businessCountData = ref<any>({});
const complainCountData = ref<any>({});
onBeforeMount(async () => {
  const businessCountDataRes = await queryBusinessCountData({}) as any
  if (businessCountDataRes.code == 200) {
    businessCountData.value = businessCountDataRes.result;
  }
  console.log("businessCountData====", businessCountData.value);
  const complainCountDataRes = await queryComplainCountData({}) as any
  if (complainCountDataRes.code == 200) {
    complainCountData.value = complainCountDataRes.result;
  }
  console.log("complainCountData====", complainCountData.value);
  const res = await queryPreServiceCountData({pageNo: 1, pageSize: 100}) as any
  if (res.code == 200) {
    itemList.value = res.result.records;
    itemList.value.map((item) => {
      item.createTime = dayjs(item.createTime).format("YYYY-MM-DD")
    })
    console.log("itemList.value====", itemList.value);
  }
})


return (_ctx: any,_cache: any) => {
  const _component_Top = _resolveComponent("Top")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_Bottom = _resolveComponent("Bottom")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Top, { fixedNobanner: true }),
    _cache[3] || (_cache[3] = _createElementVNode("div", {
      class: "no_banner",
      id: "no_banner"
    }, null, -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "t6_breadCream" }, [
            _createElementVNode("span", null, "首页"),
            _createTextVNode(),
            _createElementVNode("i", null, ">"),
            _createElementVNode("span", null, "审批（服务）公示")
          ], -1)),
          _createElementVNode("div", _hoisted_4, [
            _cache[1] || (_cache[1] = _createElementVNode("div", null, null, -1)),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", null, [
                _createVNode(_component_el_descriptions, {
                  class: "margin-top",
                  title: "",
                  column: 4
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_descriptions_item, { label: "当日办件量:" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(businessCountData.value.drbjzl) + "件", 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_descriptions_item, { label: "月度办件量:" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(businessCountData.value.ydbjzl) + "件", 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_descriptions_item, { label: "年度办件量:" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(businessCountData.value.ndbjzl) + "件", 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_descriptions_item, { label: "办件总量:" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(businessCountData.value.bjzl) + "件", 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_descriptions_item, { label: "投诉量:" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(complainCountData.value.tsl) + "件", 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_descriptions_item, { label: "投诉回复量:" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(complainCountData.value.tshfl) + "件", 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_descriptions_item, { label: "咨询量:" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(complainCountData.value.zxl) + "件", 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_descriptions_item, { label: "咨询回复量:" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(complainCountData.value.zxhfl) + "件", 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("table", _hoisted_6, [
              _cache[0] || (_cache[0] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { style: {"width":"25%","text-align":"center"} }, "申办流水号"),
                  _createElementVNode("th", { style: {"width":"20%","text-align":"center"} }, "公司名称"),
                  _createElementVNode("th", { style: {"width":"25%","text-align":"center"} }, "事项名称"),
                  _createElementVNode("th", { style: {"width":"15%","text-align":"center"} }, "所属部门"),
                  _createElementVNode("th", { style: {"width":"15%","text-align":"center"} }, "申请时间"),
                  _createElementVNode("th", { style: {"width":"10%","text-align":"center"} }, "当前状态")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_7, [
                    _createElementVNode("table", _hoisted_8, [
                      (itemList.value.length>0)
                        ? (_openBlock(), _createBlock(_unref(Vue3SeamlessScroll), {
                            key: 0,
                            class: "seamless-warp1",
                            list: itemList.value
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itemList.value, (item, index) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: index,
                                  style: {"width":"1200px"}
                                }, [
                                  _createElementVNode("td", _hoisted_9, _toDisplayString(item.projid), 1),
                                  _createElementVNode("td", _hoisted_10, _toDisplayString(item.applyname), 1),
                                  _createElementVNode("td", _hoisted_11, _toDisplayString(item.servicename), 1),
                                  _createElementVNode("td", _hoisted_12, _toDisplayString(item.deptname), 1),
                                  _createElementVNode("td", _hoisted_13, _toDisplayString(item.createTime), 1),
                                  _createElementVNode("td", _hoisted_14, _toDisplayString(item.handlestate), 1)
                                ]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["list"]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_Bottom)
  ], 64))
}
}

})